class AccessTokenStateDto {
  /** accessToken */
  accessToken = "";

  /** 是否可用 true：可用，false：不可用 */
  available = false;

  /** 过期时间 */
  expiresIn = undefined;
}

class LoginResponseDto {
  /** accessExpiresIn */
  accessExpiresIn = undefined;

  /** accessToken */
  accessToken = "";

  /** clientCode */
  clientCode = "";

  /** expiresIn */
  expiresIn = undefined;

  /** refreshExpiresIn */
  refreshExpiresIn = undefined;

  /** refreshToken */
  refreshToken = "";

  /** serviceTicket */
  serviceTicket = "";

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** username */
  username = "";
}

class LoginStateDto {
  /** 状态码 0：未登录，1：已登录，2：已取消 */
  stateCode = undefined;

  /** 状态信息 */
  stateMsg = "";

  /** 唯一标识符 */
  uniqueIdentifier = "";
}

class ModelAndView {
  /** empty */
  empty = false;

  /** model */
  model = undefined;

  /** modelMap */
  modelMap = undefined;

  /** reference */
  reference = false;

  /** status */
  status = "ACCEPTED";

  /** view */
  view = new View();

  /** viewName */
  viewName = "";
}

class ResourceVerificationLevelDto {
  /** clientCode */
  clientCode = "";

  /** uriMap */
  uriMap = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new AccessTokenStateDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ServiceTicketCheckDto {
  /** 结果 成功或失败 */
  result = false;

  /** serviceTicket */
  serviceTicket = "";
}

class ServiceTicketRequestDto {
  /** serviceTicket */
  serviceTicket = "";
}

class TokenInfo {
  /** accessToken */
  accessToken = "";
}

class UCenterAccessTokenStateDto {
  /** accessToken */
  accessToken = "";

  /** 是否可用 true：可用，false：不可用 */
  available = false;

  /** 过期时间 */
  expiresIn = undefined;

  /** 用户工号 */
  jobNo = "";
}

class View {
  /** contentType */
  contentType = "";
}

export const auth = {
  AccessTokenStateDto,
  LoginResponseDto,
  LoginStateDto,
  ModelAndView,
  ResourceVerificationLevelDto,
  Response,
  ResponseDto,
  ServiceTicketCheckDto,
  ServiceTicketRequestDto,
  TokenInfo,
  UCenterAccessTokenStateDto,
  View,
};
